import { FormulaOperation } from "./FormulaOperation";

export const calculateOperation: Record<
  FormulaOperation,
  (stack: number[]) => void
> = {
  "+": (stack) => binOp((a, b) => a + b, stack),
  "-": (stack) => binOp((a, b) => a - b, stack),
  "*": (stack) => binOp((a, b) => a * b, stack),
  "/": (stack) => binOp((a, b) => a / b, stack),
  "^": (stack) => binOp((a, b) => a ** b, stack),
  "~": (stack) => unOp((a) => -a, stack),
};

export const checkNumber = (value: number | undefined, msg: string): number => {
  if (typeof value !== "number") throw Error(msg);
  return value;
};

const binOp = (fn: (a: number, b: number) => number, stack: number[]): void => {
  const a = checkNumber(stack.shift(), "Отсутствует аргумент 1");
  const b = checkNumber(stack.shift(), "Отсутствует аргумент 2");
  stack.push(fn(a, b));
};

const unOp = (fn: (a: number) => number, stack: number[]): void => {
  const a = checkNumber(stack.shift(), "Отсутствует аргумент");
  stack.push(fn(a));
};
